import React from 'react';
import { TextareaProps } from '../types';
import styles from './Textarea.module.scss';

export const Textarea: React.FC<TextareaProps> = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  required = false,
  maxLength,
  rows = 4,
  fullWidth = true,
  className = '',
  ...props
}) => {
  const containerClasses = [
    styles.textareaContainer,
    fullWidth ? styles.fullWidth : '',
    className
  ].filter(Boolean).join(' ');

  const textareaClasses = [
    styles.textarea,
    error ? styles.error : ''
  ].filter(Boolean).join(' ');

  const currentLength = value?.length || 0;
  const isNearLimit = maxLength && currentLength > maxLength * 0.9;
  const isOverLimit = maxLength && currentLength > maxLength;

  const charCountClasses = [
    styles.charCount,
    isOverLimit ? styles.error : isNearLimit ? styles.warning : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span className={styles.required}> *</span>}
        </label>
      )}
      <textarea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={textareaClasses}
        rows={rows}
        maxLength={maxLength}
        {...props}
      />
      {error && <span className={styles.errorText}>{error}</span>}
      {!error && helperText && <span className={styles.helperText}>{helperText}</span>}
      {maxLength && (
        <span className={charCountClasses}>
          {currentLength} / {maxLength}
        </span>
      )}
    </div>
  );
};
